import { BsFileEarmarkPlus, BsFileEarmarkX } from 'react-icons/bs';
import { PatientProfile, TableColumnAction } from 'utils/models';
import { useTranslation } from 'react-i18next';
import { useDrawerContext } from 'context/hooks';
import { CreatePrescription } from 'pages/Main/Patients/CreatePrescription/CreatePrescription';
import { DeactivePrescription } from 'pages/Main/Patients/DeactivePrescription/DeactivatePrescription';

export const usePatientListActions = (): TableColumnAction<PatientProfile>[] => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawerContext();

  const handleCreatePrescriptionClick = (patient: PatientProfile) => {
    openDrawer({
      content: <CreatePrescription patient={patient} />,
      size: '80%',
      title: t('navbar_create_prescription'),
    });
  };

  const handleDeactivatePrescriptionClick = (patient: PatientProfile) => {
    openDrawer({
      content: <DeactivePrescription patient={patient} />,
      title: t('deactivate_prescription_label'),
    });
  };

  const actions: TableColumnAction<PatientProfile>[] = [
    {
      icon: <BsFileEarmarkPlus color={'var(--mantine-color-blue-5)'} size={16} />,
      tooltip: t('navbar_create_prescription'),
      onClick: (item) => handleCreatePrescriptionClick(item),
    },
    {
      icon: <BsFileEarmarkX color={'var(--mantine-color-red-5)'} size={16} />,
      tooltip: t('deactivate_prescription_label'),
      visible: (item) => item.groups.find((group) => !group.expired) !== undefined,
      onClick: handleDeactivatePrescriptionClick,
    },
  ];

  return actions;
};
